/* eslint-disable linebreak-style */
/* eslint-disable comma-dangle */
import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { TITLE_ID } from '../../Constants';
import './SendVerificationEmail.css';

function ShowResend({
  isActive,
  setShowRefresh
}) {
  function sendAccountVerificationEmail() {
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'SendAccountVerificationEmail',
          FunctionParameter: {
            SessionTicket: window.sessionStorage.getItem('session_ticket'),
          },
        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        if (response.data.data.FunctionResult.message !== 'Success') {
          toast.error(
            'Error sending verification email',
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
        } else {
          toast.success(
            'Verification email sent!',
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
          setShowRefresh(true);
        }
      });
  }

  ShowResend.propTypes = {
    isActive: PropTypes.bool.isRequired,
    setShowRefresh: PropTypes.func.isRequired
  };

  return (
    <section className="panel">
      { isActive && (
      <div className="verify-modal">
        <div className="verify-modal-content">
          <h1 className="verify-modal-content title">ACCOUNT VERIFICATION</h1>
          <h2>
            To access this feature, you must verify your account.
            Press 'SEND!' below to re-send a verification email to your registered address.
          </h2>
          <button
            type="button"
            className="verify-btn"
            onClick={sendAccountVerificationEmail}
          >
            SEND!
          </button>
        </div>
      </div>
      )}
    </section>
  );
}

function ShowRefresh(props) {
  const {
    isActive,
    setPlayerVerified
  } = props;

  let foundVerification = false;

  function onRefresh() {
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/Client/GetPlayerProfile`,
        {
          PlayFabId: window.sessionStorage.getItem('player_verified'),
          ProfileConstraints: {
            ShowDisplayName: true,
            ShowCreated: true,
            ShowLastLogin: true,
            ShowTags: true,
            ShowContactEmailAddresses: true
          }
        },
        {
          headers: {
            'X-Authorization': window.sessionStorage.getItem('session_ticket'),
          },
        },
      ).then((getPlayerProfileResponse) => {
        const addresses = getPlayerProfileResponse.data.data.PlayerProfile.ContactEmailAddresses;
        addresses.forEach((emailInfo) => {
          if (emailInfo.VerificationStatus.includes('Confirmed')) {
            foundVerification = true;
            setPlayerVerified(true);
          }
        });
        if (!foundVerification) {
          toast.error(
            'Email has not been confirmed.',
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
        }
      });
  }

  ShowRefresh.propTypes = {
    isActive: PropTypes.bool.isRequired,
    setPlayerVerified: PropTypes.func.isRequired
  };

  return (
    <section className="panel">
      { isActive && (
      <div className="verify-modal">
        <div className="verify-modal-content">
          <h1 className="verify-modal-content title">VERIFICATION EMAIL SENT!</h1>
          <h2>
            Once you've verified your email using the link sent to your registered address,
            you will have full access to the portal. Then press the REFRESH button, below
            to reload the page!
          </h2>
          <button
            type="button"
            className="verify-btn"
            onClick={onRefresh}
          >
            REFRESH
          </button>
        </div>
      </div>
      )}
    </section>
  );
}

function SendVerificationEmail(props) {
  const {
    setPlayerVerified
  } = props;
  const [showRefresh, setShowRefresh] = useState(false);

  SendVerificationEmail.propTypes = {
    setPlayerVerified: PropTypes.func.isRequired
  };

  return (
    <>
      <ShowResend
        isActive={!showRefresh}
        setShowRefresh={() => setShowRefresh(true)}
      />
      <ShowRefresh isActive={showRefresh} setPlayerVerified={setPlayerVerified} />
    </>
  );
}
export default SendVerificationEmail;
